"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeGridClasses = composeGridClasses;
var _utils = require("@mui/utils");
var _gridClasses = require("../constants/gridClasses");
function composeGridClasses(classes, slots) {
  return (0, _utils.unstable_composeClasses)(slots, _gridClasses.getDataGridUtilityClass, classes);
}